import { render, staticRenderFns } from "./DocGerenciarUsuario.vue?vue&type=template&id=0f7cef56&scoped=true"
import script from "./DocGerenciarUsuario.vue?vue&type=script&lang=js"
export * from "./DocGerenciarUsuario.vue?vue&type=script&lang=js"
import style0 from "./DocGerenciarUsuario.vue?vue&type=style&index=0&id=0f7cef56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7cef56",
  null
  
)

export default component.exports